import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { PushCounterRow, StyledPushCounter } from "@/components/PushCounter";
import { colors } from "@/styles/utils/vars";
import { ButtonBase } from "@/ui/Button/StyledButton";
import { cssIcon } from "@/ui/Icon";
import { getTypographyBase, Span } from "@/ui/Typography/Typography";
export const StyledFooterBar = /*#__PURE__*/styled('section')({
  name: "StyledFooterBar",
  class: "StyledFooterBar_sncpd0f"
});
export const MenuBar = /*#__PURE__*/styled('div')({
  name: "MenuBar",
  class: "MenuBar_m170mms"
});
export const StyledCaption = /*#__PURE__*/styled('span')({
  name: "StyledCaption",
  class: "StyledCaption_s1pj1vw"
});
export const cssIsActive = "cssIsActive_cqccni7";
export const cssItem = "cssItem_cizbmzr";

require("./Styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Styled.tsx");